import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ResetPassword from "@/pages/ResetPassword";
export const Route = createFileRoute("/reset-password")({ head: ({match}) => pageHead(match.pathname), component: () => (<ResetPassword />) });
